import { Card, Form, Input, AutoComplete, Select } from 'antd';
import { DebouncedFunc } from 'lodash';
import React, { useEffect, useState, useMemo } from 'react';
import { createId } from '@/pages/xiaohongshu/components/card';
import { DeleteOutlined, CopyOutlined } from '@ant-design/icons';

const defaultKeywords = [
  ['甲癌','甲状腺癌','乳头状癌','乳头状','甲状腺结节','甲状腺','甲亢','甲减','甲状腺囊肿','桥本','甲状腺弥漫性病变','乳腺结节','结节','肺结节','毛玻璃结节','甲状腺结节','4a','3级结节','4a结节','结节4a','4级结节','结节4级', '乳腺增生','肌瘤', '息肉', '囊肿', '结石', '大三阳', '小三阳', '乙肝', '高血压', '尿酸', '糖尿病', '血脂'],
  ['宝宝','孩子','小孩','儿童','小孩子','儿子','女儿','闺女', '小神兽','未来星','半岁','个月','2岁'],
  ['计划书','收益表','收益计划书','收益演示表','收Y演示表','理财','增额终身寿','增额产品','增额终身寿险','乐享年年','利益表']
];

type IndexProps = {
  situation: API.Situation,
  workerVersions: API.SelectOption[],
  handleSituationsChange: DebouncedFunc<(value: API.Situation) => void>;
  copySituation: (s: API.Situation) => void;
  deleteSituation: (sId: string) => void;
}

const Index: React.FC<IndexProps> = ({ situation, handleSituationsChange, copySituation, deleteSituation, workerVersions }) => {
  const [form] = Form.useForm();

  const keywordOptions = useMemo(() => {
    return defaultKeywords.map((vo) => {
      return { value: vo.join('|') };
    })
  }, []);

  const onValuesChange = (changedValues: any, values: any) => {
    handleSituationsChange({ ...values, id: situation.id });
  }

  useEffect(() => {
    form.setFieldsValue(situation);
  }, [situation]);

  return <Card
    style={{ width: '100%', boxShadow: '2px 2px 8px rgba(0, 0, 0, 0.3)' }}
    actions={[
      <DeleteOutlined onClick={() => deleteSituation(situation.id)} />,
      <CopyOutlined onClick={() => copySituation({ ...situation, id: createId() })} />,
    ]}
  >
    <Form
      name="basic"
      form={form}
      labelCol={{ span: 6 }}
      wrapperCol={{ span: 18 }}
      initialValues={{ remember: true }}
      onValuesChange={onValuesChange}
      autoComplete="off"
    >
      <Form.Item
        label="关键词"
        name="keywords"
      >
        <AutoComplete
          options={keywordOptions}
        >
          <Input.TextArea
            placeholder="关键词请使用'|'符号隔开"
            style={{ height: 80 }}
          />
        </AutoComplete>
      </Form.Item>
      <Form.Item
        label="联系电话"
        name="phone"
      >
        <Input />
      </Form.Item>
      <Form.Item
        label="二维码"
        name="qrcode"
        rules={[{ required: true, message: 'Please input your password!' }]}
      >
        <Select options={workerVersions} />
      </Form.Item>
      <Form.Item
        label="附带引导语"
        name="followup"
        rules={[{ required: true, message: 'Please input your password!' }]}
      >
        <Input.TextArea autoSize={{ minRows: 3 }} />
      </Form.Item>
    </Form>
  </Card>
}

export default React.memo(Index);